const getters = {
  getRenewal: (state) => state.renewal,
  getRenewals: (state) => state.renewals,
  getRenewalsMeta: (state) => state.renewalsMeta,
  getPartners: (state) => state.partners,
  getProductCategories: (state) => state.productCategories,
};

export default getters;
